import { state } from './state';
import { SMART_INTEREST_SELECTION_HISTORY, SmartInterestType } from '../../../const/state/adgroup';
export const mutations = {
  setSelectionHistory(val: SMART_INTEREST_SELECTION_HISTORY): void {
    state.selection_history.value = SMART_INTEREST_SELECTION_HISTORY.EDITED;
  },
  setSmartInterestSelection(val: boolean): void {
    state.smart_interest_selection.value = val ? SmartInterestType.CHECK : SmartInterestType.UNCHECK;
  },
  showSmartInterest(val: boolean): void {
    state.showSmartInterestToggle.value = val;
  },
  resetDefaultValues(): void {
    state.smart_interest_selection.value = SmartInterestType.CHECK;
    state.selection_history.value = SMART_INTEREST_SELECTION_HISTORY.UNEDITED;
  },
  removeSmartInterestState(): void { // Different than resetDefaultState
    state.selection_history.value = SMART_INTEREST_SELECTION_HISTORY.UNEDITED;
    state.smart_interest_selection.value = SmartInterestType.UNCHECK;
  }
};
